import { AbstractControl, ValidatorFn } from '@angular/forms';
import { BOOKER_CONFIG } from '@shared/booker';

import { CityPair } from '.';

export class CityPairSelectorValidators {
  static destinationCuba: ValidatorFn = (
    control: AbstractControl<CityPair>,
  ) => {
    const code = control.value?.destination?.code;

    return code && !!BOOKER_CONFIG.BOOKER_VACATIONS_CONFIG.CUBA[code]
      ? { cubaDestination: true }
      : null;
  };

  static bothInternationalFlights: ValidatorFn = (
    control: AbstractControl<CityPair>,
  ) => {
    const origin = control.value?.origin;
    const destination = control.value?.destination;
    if (!origin || !destination) {
      return null;
    }
    const originOverride = BOOKER_CONFIG.INTERNATIONAL_EXCEPTIONS[origin.code];
    const destinationOverride =
      BOOKER_CONFIG.INTERNATIONAL_EXCEPTIONS[destination.code];
    // If airport is in exception list, overwrite its country code
    const originCode = !!originOverride ? originOverride : origin.countryCode;
    const destinationCode = !!destinationOverride
      ? destinationOverride
      : destination.countryCode;

    return originCode !== 'US' && destinationCode !== 'US'
      ? { bothInternationalFlights: true }
      : null;
  };
}
